import styled, {keyframes} from "styled-components";

interface IProps {
    className?: string;
}

const LoaderAnimation = keyframes`
    to {
        transform: rotate(1turn)
    }
`;
const Loader = styled.div`
    aspect-ratio: 1;
    border-radius: 50%;
    border: 4px solid lightblue;
    border-right-color: white;
    animation: ${LoaderAnimation} 1s infinite linear;
`;

const CircleLoader = ({className = "w-5"} : IProps) => {
    return <Loader className={className}/>;
};

export default CircleLoader;